import React, { Component } from 'react'
import { Col, Form, InputNumber, Row } from 'antd'
import { compose } from 'recompose'
import { get } from 'lodash'
import withLoadingSection from '../../../../elements/HOC/withLoadingSection'
import { dateFormat, dateVal, moneyInline, numVal, strVal } from '../../../../modules/Utils'

class ReceiptForm extends Component {
  render () {
    const { getFieldDecorator } = this.props.form
    const {
      receipt,
      transaction,
      onChangeContractAllocated,
      calculation,
    } = this.props
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18, offset: 1 },
      },
    }
    return (
      <Form layout={'horizontal'}>
        <Row>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Amount'}>
              {moneyInline(
                numVal(transaction, 'amount'),
                strVal(transaction, 'currency'),
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Bank Fees'}>
              {moneyInline(
                numVal(transaction, 'bankFees'),
                strVal(transaction, 'currency'),
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Payer'}>
              {strVal(transaction, 'remittance.order')}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Company'}>
              {strVal(transaction, 'company.fn')}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Bank Account'}>
              {strVal(transaction, 'bank.title')}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Date'}>
              {dateFormat(dateVal(transaction, 'date'))}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...formItemLayout} label={'Notes'}>
              {strVal(transaction, 'notes')}
            </Form.Item>
          </Col>
        </Row>
        <Col span={12}>
          <Form.Item {...formItemLayout} label={'Client'}>
            <span>{get(receipt, 'client.fn')}</span>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...formItemLayout} label={'Contract '}>
            <span>{get(receipt, 'contract.title')}</span>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...formItemLayout} label={'Deposit to Account'}>
            {getFieldDecorator('contract.amount', {
              initialValue: get(receipt, 'contract.amount'),
            })(
              <InputNumber
                style={{ width: '50%' }}
                onChange={onChangeContractAllocated}
              />,
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...formItemLayout} label={'Invoices Allocation'}>
            {moneyInline(
              numVal(calculation, 'allocated'),
              strVal(transaction, 'currency'),
            )}
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item {...formItemLayout} label={'Total Invoices Balance'}>
            {moneyInline(
              numVal(calculation, 'total'),
              strVal(transaction, 'currency'),
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            style={{
              color:
                numVal(calculation, 'remaining') === 0 ? '#44ad4f' : '#f5222d',
            }}
            {...formItemLayout}
            label={'Transaction Remaining'}>
            {moneyInline(
              numVal(calculation, 'remaining'),
              strVal(transaction, 'currency'),
            )}
          </Form.Item>
        </Col>
      </Form>
    )
  }
}

ReceiptForm.propTypes = {}
ReceiptForm.defaultProps = { transaction: {}, receipt: {}, type: 'new' }

export default compose(Form.create(), withLoadingSection)(ReceiptForm)
